var render, staticRenderFns
import script from "./TxSettingsUi.vue?vue&type=script&lang=js&"
export * from "./TxSettingsUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c82e46",
  null
  
)

export default component.exports